// pages/Config/WifiPlanEditPage.jsx
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageContainer from '../../../layouts/PageContainer';
import PageHeader from '../../../components/Nav/PageHeader';
import WifiPlanForm from '../../../components/Config/WifiPlanForm';
import { mapPlanToForm } from '../../../util/wifiPlan.mappers';
import { useConfig } from '../../../DataStore/ConfigContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';

export default function WifiPlanEditPage() {
  const navigate = useNavigate();
  const { selectedWifiPlan, getWifiPlans } = useConfig();
  const [initialValues, setInitialValues] = useState();
  const [loading, setLoading] = useState(true);

  // If no selected plan in context, bounce back to list
  useEffect(() => {
    if (!selectedWifiPlan) {
      navigate('/settings/plans');
    }
  }, [selectedWifiPlan, navigate]);

  // Map context plan -> form initial values
  useEffect(() => {
    if (!selectedWifiPlan) return;
    setLoading(true);
    setInitialValues(mapPlanToForm(selectedWifiPlan));
    setLoading(false);
  }, [selectedWifiPlan]);

  // Prefer numeric id if possible, otherwise keep as-is
  const editId =
    selectedWifiPlan && /^\d+$/.test(String(selectedWifiPlan.id))
      ? Number(selectedWifiPlan.id)
      : selectedWifiPlan?.id;


  const saveChanges = async(changes)=>{
    const server_response = await ajaxConfig.updateWifiPlan(changes);
     if (server_response.status === "OK") {
      getWifiPlans(true);
      navigate('/settings/plans', { state: { flash: { type: 'success', msg: server_response.message || 'Plan updated.' } } });
      return { ok: true, message: server_response };
    }
    return { ok: false, message: server_response.message || 'Failed to update plan.' };
  }

  return (
    <PageContainer>
      <PageHeader
        title="Edit WiFi Plan"
        breadcrumb={
          <>
            <li className="breadcrumb-item">
              <Link to="/settings">Settings</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/settings/plans">WiFi Plans</Link>
            </li>
            <li className="breadcrumb-item active">Edit</li>
          </>
        }
      />
      <div className="container-fluid">
        {loading ? (
          <div className="spinner-border" />
        ) : (
          <WifiPlanForm
            editingId={editId}
            initialValues={initialValues}
            onSubmit={async (payload, { id: eid }) => {
              const changes = {
                id: eid,
                plan_name: payload.plan_name,
                price: payload.price,
                notes: payload.description,
                ...(payload.attrs || {}),
              };

              await saveChanges(changes);
            }}
          />
        )}
      </div>
    </PageContainer>
  );
}
